<template>
<div class="page">
  <div style="width: 100%; display: flex; justify-content: center;">
    <TopBar></TopBar>
  </div>
  <div class="title">Table of Algorithms Considered</div>
  <div v-if="ready" class="table">
    <AlgoRow v-for="(algo, idx) in algorithms" :key="idx" :algo="algo"></AlgoRow>
  </div>
</div>
</template>

<script>
import TopBar from "@/components/TopBar";
import AlgoRow from "@/components/AlgoRow";
import {apiAlgos} from "@/api/algos";
import {ref} from "vue"
export default {
  name: "Table",
  components: {AlgoRow, TopBar},
  setup() {
    let algorithms = ref([]);
    let ready = ref(true);
    apiAlgos(algorithms, ready);
    return {
      algorithms,
      ready
    };
  },
  mounted() {

  }


}
</script>

<style scoped>
.page {
  width: 900px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

}
.title {
  margin-top: 10px;
  margin-bottom: 25px;
  font-size: 20px;
  font-weight: bold;
}
.table{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>